import React from 'react';
import { Modal } from 'rsuite';
import { AllegroImpliedWarranty } from '../../../../api/allegro/impliedwarranty/impliedWarrantyTypes';
import EshopSetupAllegroImpliedWarrantyEdit from './Edit/EshopSetupAllegroImpliedWarrantyEdit';

const EDIT_TITLE = 'Edit complaints terms';
const CREATE_TITLE = 'Create complaints terms';

interface Props {
  isOpen: boolean;
  marketplaceCode: string;
  impliedWarranty?: AllegroImpliedWarranty;
  onClose: () => void;
  onSaved: () => void;
}

export default function EshopSetupAllegroImpliedWarrantyEditModal({
  isOpen,
  marketplaceCode,
  impliedWarranty,
  onClose,
  onSaved,
}: Props): JSX.Element {
  const title = impliedWarranty ? EDIT_TITLE : CREATE_TITLE;

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      backdrop="static"
      overflow
    >
      <Modal.Header>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EshopSetupAllegroImpliedWarrantyEdit
          marketplaceCode={marketplaceCode}
          impliedWarranty={impliedWarranty}
          onCancel={() => onClose()}
          onSaved={() => onSaved()}
        />
      </Modal.Body>
    </Modal>
  );
}

EshopSetupAllegroImpliedWarrantyEditModal.defaultProps = {
  impliedWarranty: undefined,
};
